import { render, staticRenderFns } from "./saleStatistic.vue?vue&type=template&id=15ea12d8&scoped=true"
import script from "./saleStatistic.vue?vue&type=script&lang=js"
export * from "./saleStatistic.vue?vue&type=script&lang=js"
import style0 from "./saleStatistic.vue?vue&type=style&index=0&id=15ea12d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ea12d8",
  null
  
)

export default component.exports